"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFooterContentContainer = void 0;
var _ykbStyledComponents = require("../../ykb-styled-components");
var StyledFooterContentContainer = exports.StyledFooterContentContainer = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-2mm0o8-0"
})(["", ";margin:0 -", ";padding:", " ", ";", ""], function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.theme.table.paddingVertical;
}, function (props) {
  return props.theme.table.paddingHorizontal;
}, function (props) {
  return props.$hasPagination && (0, _ykbStyledComponents.css)(["border-top:", ";"], function (props) {
    return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
  });
});